<template>
  <div class="mt-5 containerContatos">
    <b-row align-h="start">
      <b-col class="mb-3 dropdown1" cols="8" md="6">
        <b-dropdown class="dropdown" text="Filtros">
          <b-dropdown-item @click="aproved1(undefined)">Todos</b-dropdown-item>
          <b-dropdown-item @click="aproved1(true)">Aprovadas</b-dropdown-item>
          <b-dropdown-item @click="aproved1(false)">Não aprovadas</b-dropdown-item>
        </b-dropdown>
      </b-col>
      <b-col class="input-search" cols="10" md="6" lg="6">
        <b-input-group>
          <template v-slot:prepend>
            <b-input-group-text>
              <b-icon-search></b-icon-search>
            </b-input-group-text>
          </template>
          <b-form-input
            trim
            autocomplete="off"
            placeholder="Pesquisar"
            type="text"
            v-model="searchText"
          />
        </b-input-group>
      </b-col>
    </b-row>
    <PopupConfirmacao
      cor_imagem="#E2574C"
      titulo="Atenção"
      texto="A postagem será excluida permantemente. Deseja continuar?"
      texto_botao1="Continuar"
      cor_botao1="#FFFFFF"
      cor_background_botao1="#EB5353"
      hover_botao1="#a53a36"
      texto_botao2="Cancelar"
      cor_botao2="#FFFFFF"
      cor_background_botao2="#ADADAD"
      hover_botao2="#8b8b8b"
      :confirma_acao="deletar"
      id_modal="idModal"
    />
    <b-row align-h="start">
      <b-col class="coltable col-sm-12 col-md-12 col-lg-12">
        <b-table
          hover
          bordered
          responsive
          class="mt-3 mb-5 table"
          id="my-table"
          :items="myItems"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="searchText"
        >
          <!-- Ultima coluna, coluna dos icones  -->
          <template v-slot:cell(buttons)="data">
            <div class="div-itens">
              <router-link
                :to="`/dashboard/postagens/editar/${data.item.id}`"
                style="margin-right: 1rem; margin-top: 1rem"
              >
                <b-icon-arrow90deg-right
                  class="icons"
                  scale="1"
                ></b-icon-arrow90deg-right>
              </router-link>
              <a
                style="margin-right: 0.5rem; margin-top: 1rem"
                v-b-modal.idModal
                @click="abrirModal(data.item)"
              >
                <b-icon-trash class="icons" scale="1"></b-icon-trash>
              </a>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row class="rowPagination" align-h="end">
      <b-pagination
        class="pagination"
        :total-rows="rows"
        :per-page="perPage"
        v-model="currentPage"
        style="margin-top: -30px; margin-bottom: 22px"
      >
      </b-pagination>
    </b-row>
    <ModalAlert idModal="excluido" msg="Post deletado com sucesso!" colorFont="green" />
  </div>
</template>

<script>
import PopupConfirmacao from '@/components/dashboard/PopupConfirmacao.vue';
import ModalAlert from '@/components/dashboard/ModalAlert.vue';
import {
  GetAnonymousContact,
  deleteAnonymousContact,
} from '@/services/api/AnonymousContact.js';
export default {
  components: {
    PopupConfirmacao,
    ModalAlert,
  },
  data() {
    return {
      searchText: '',

      aproved: undefined,
      perPage: 0,
      rows: 0,
      currentPage: 1,
      fields: [
        {
          key: 'question',
          label: 'Remetente',
          tdClass: 'question',
          thClass: 'th-question',
        },
        {
          key: 'answer',
          label: 'Assunto',
          tdClass: 'answer',
          thClass: 'th-answer',
        },
        {
          key: 'buttons',
          label: '',
          tdClass: 'buttons',
          thClass: 'th-buttons',
        },
      ],
      INDEX: 0,
      items: [],
      dados: {
        id: '',
        mailer: '',
        message: '',
      },
    };
  },
  methods: {
    aproved1(aproved) {
      this.aproved = aproved;
      this.$root.$emit('bv::refresh::table', 'my-table');
    },
    myItems(ctx, callback) {
      if (this.searchText != '') {
        ctx.currentPage = 1;
      }
      GetAnonymousContact(ctx.currentPage, this.searchText, this.aproved)
        .then((res) => {
          let items = res.data.anonymousContacts.map((item) => {
            return {
              question: item.mailer,
              answer: item.message,
              id: item._id,
              aproved: item.aproved,
            };
          });

          this.perPage = res.data.anonymousContactsPerPage;
          this.rows = res.data.anonymousContactsCount;

          callback(items);
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 404) {
              callback([]);
            }
          } else {
            this.$bvToast.toast(
              'Erro interno no servidor, recarregue a página. Caso persista, tente novamente mais tarde.',
              {
                title: 'Erro interno no servidor',
                autoHideDelay: 5000, //Tempo em milissegundos para o toast desaparecer
                variant: 'danger', //Danger é a variante vermelha. Variantes: default, primary, secondary, danger,warning, success e info
              },
            );
          }
          callback([]);
        });
    },
    forceRerender() {
      this.$router.go(0);
    },
    deletar() {
      deleteAnonymousContact(this.dados.id)
        .then(() => {
          this.$bvModal.hide('idModal');
          this.$root.$emit('bv::refresh::table', 'my-table');
          this.$root.$emit('bv::show::modal', 'excluido');
          setTimeout(() => {
            this.$root.$emit('bv::hide::modal', 'excluido');
          }, 2000);
        })
        .catch((err) => {
          console.error(err);
          this.$bvToast.toast(
            'Erro interno no servidor, recarregue a página. Caso persista, tente novamente mais tarde.',
            {
              title: 'Erro interno no servidor',
              autoHideDelay: 5000, //Tempo em milissegundos para o toast desaparecer
              variant: 'danger', //Danger é a variante vermelha. Variantes: default, primary, secondary, danger,warning, success e info
            },
          );
        });
    },
    abrirModal(item) {
      this.dados = item;
      console.log(this.dados);
      this.$bvModal.show('idModal');
    },
  },
};
</script>

<style lang="scss" scoped>
.containerContatos {
  margin-right: 1rem;
}
.rowPagination {
  margin-right: 0.3rem;
}
@media (max-width: 325px) {
  .dropdown1 {
    margin-right: 3rem;
  }
}

@media (max-width: 280px) {
  .rowPagination {
    text-align: center;
    margin-right: 0rem;
    margin-left: 12rem;
  }
}
</style>

<style lang="scss">
.containerContatos {
  .btn-secondary {
    background-color: #343842;
  }
  #invt-modal .modal-header,
  #invt-modal .modal-footer {
    display: none;
  }
  .question {
    text-align: left;
    font-weight: 300;
    border-right: 3px solid #343842 !important;
  }

  .th-question {
    width: 9rem;
    border-bottom: 3px solid #343842 !important;
    border-right: 3px solid #343842 !important;
    text-align: left;
  }

  .answer {
    text-align: left;
    font-weight: 300;
  }

  @media (max-width: 1100px) {
    .answer {
      max-width: 400px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .th-answer {
    border-bottom: 3px solid #343842 !important;
    text-align: left;
  }

  .th-buttons {
    width: 2rem;
    border-left-style: hidden !important;
    border-bottom: 3px solid #343842 !important;
  }

  .buttons {
    padding: unset !important;
    border-left-style: hidden !important;
  }

  .div-itens {
    width: 100%;
    height: 100%;
    display: flex;
    vertical-align: middle;
    align-items: center;
    align-content: center;
    justify-content: center;
  }

  .icons {
    color: #000;
  }
  .icons:hover {
    color: #343842 !important;
  }
  .pagination .page-link,
  .pagination .page-link:hover {
    color: #343842;
  }
  .pagination .page-item.active .page-link {
    background-color: #343842;
    color: #e5e5e5;
  }
  .pagination .page-item.active .page-link:hover {
    color: #e5e5e5;
  }

  .row-hidden {
    display: none;
  }
}
</style>
